import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import { UpdateLang } from "_actions";
import { logout } from "_actions";
// Swiper CSS'lerini import et
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const BannerCarousel = (props) => {
  const navigate = useNavigate();
  const { currentLang } = props;

  const handleBannerClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

   const banners = [
     {
      id: 5,
      img: require(`../../../assets/img/home/sports.png`),
      gradient: "from-blue-600 to-blue-800",
      path: "/sports"
    },
    {
      id: 1,
      img: require(`../../../assets/img/home/slots.png`),
      gradient: "from-blue-600 to-blue-800",
      path: "/casino"
    },
    {
      id: 2,
      img: require(`../../../assets/img/home/livecasino.png`),

      gradient: "from-secondary-600 to-secondary-800",
      path: "/live-casino"
    },
    {
      id: 3,
      img: require(`../../../assets/img/home/womensports.png`),

      gradient: "from-green-600 to-green-800",
      path: "/"
    },
    {
      id: 4,
      img: require(`../../../assets/img/home/jackpot1.png`),

      gradient: "from-purple-600 to-purple-800",
      path: "/my-account/"
    }
  ];

  return (
    <div key={currentLang+"bannerv1"}   className="bg-[#ffffff17] md:bg-transparent relative mb-4 mt-0 md:mt-4  p-0 md:p-4 overflow-hidden max-w-screen-lg mx-auto">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        className="h-64 md:h-72 rounded-0  md:rounded-xl"
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.id}>
            <div
              className={`h-full bg-transparent relative cursor-pointer`}
              onClick={() => handleBannerClick(banner.path)}
            >
              <div className="absolute inset-0 bg-black opacity-50"></div>
             
              <div
                style={{ background: `url(${banner.img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                className="relative z-10 p-4 h-full w-full bg-contain bg-center flex flex-col justify-center bg-no-repeat">

              </div>
              <div
                style={{ backgroundImage: `url(${require('../../../assets/img/kurdt.png')})`, bottom: 20, left: 0 }}
                className="absolute z-20 h-8 w-full bg-contain bg-left bg-no-repeat">
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

 const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    UpdateLang: (data) => dispatch(UpdateLang(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BannerCarousel);
